import { Injectable } from "@angular/core";

@Injectable()
export class FileSizeUtil {
  toByteSizeDisplay(bytes: any) {
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let l = 0, n = parseInt(bytes.toString(), 10) || 0;
    while(n >= 1024 && ++l) n /= 1024;
    return(n.toFixed(2) + ' ' + units[l]);
    //return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }

  toByteSize(size: number, unit: Units) {
    let l = unit, n = size;
    while(l--) n *= 1024;
    return n;
  }
}

export enum Units {
  B = 0,
  KB,
  MB,
  GB,
  TB,
  PB
}
